import { connect } from 'react-redux';
import { State } from 'widgets/friends-referral/root/root.reducers';
import { getInvitationInfo, updateInvitationInfo, setIneligibleError } from '../friends-referral/friends-referral-store';
import { IFriendsReferralInviteeDispatchProps, IFriendsReferralInviteeStoreProps } from './friends-referral-invitee.types';
import { FriendsReferralInviteeComponent as component } from './friends-referral-invitee.component';

const mapDispatchToProps: IFriendsReferralInviteeDispatchProps = {
    getInvitationInfo,
    updateInvitationInfo,
    setIneligibleError
};

const mapStateToProps = (state: State): IFriendsReferralInviteeStoreProps => ({
    playerInfo: state.friendsReferral.playerInfo!
});

export default connect(mapStateToProps, mapDispatchToProps)(component);
